import { createFocusTrap } from 'focus-trap';

const refs = {
  openBtn: document.querySelector('.mobile-menu-open-btn'),
  closeBtn: document.querySelector('.mobile-menu-close-btn'),
  mobileMenu: document.querySelector('.mobile-menu-wrapper'),
};

let focusTrap = null;

function openMenu() {
  refs.mobileMenu?.classList.add('is-open');
  refs.openBtn?.setAttribute('aria-expanded', 'true');

  if (!focusTrap && refs.mobileMenu) {
    focusTrap = createFocusTrap(refs.mobileMenu, {
      escapeDeactivates: true,
      clickOutsideDeactivates: true,
      onDeactivate: closeMenu,
    });
  }

  focusTrap?.activate();

  refs.mobileMenu?.addEventListener('click', handleMenuItemClick);
}

function closeMenu() {
  refs.mobileMenu?.classList.remove('is-open');
  refs.openBtn?.setAttribute('aria-expanded', 'false');

  refs.mobileMenu?.removeEventListener('click', handleMenuItemClick);

  if (focusTrap?.active) {
    focusTrap.deactivate();
  }
}

function handleMenuItemClick(event) {
  const clickedLink = event.target.closest('a[href]');
  const clickedCloseElement = event.target.closest('[data-close]');

  if (clickedLink || clickedCloseElement) {
    closeMenu();
  }
}

refs.openBtn?.addEventListener('click', openMenu);
refs.closeBtn?.addEventListener('click', closeMenu);